<div class="container">
  <div class="content mobile" [style.height.px]="contentHeight()">
    <div #contentWrapper>
      <mat-spinner class="spinner" *ngIf="!viewModel.apiResult()?.meta?.productId; else content"></mat-spinner>
      <ng-template #content>
        <div class="sticky-header info">
          <button *ngIf="viewModel.currColor() ?? viewModel.apiResult().colors[0] as color"
                  appFocusRemove
                  (click)="openGallery(color)">
            <app-image-loading
              [clickable]="true"
              [src]="(viewModel.colorImages().get(color.id) ?? '')"
              [alt]="color.color?.name ?? ''"
              [priority]="true"
              [targetWidth]="70"
              [targetHeight]="70"/>
          </button>
          <div class="column-container meta" *ngIf="viewModel.apiResult().meta as meta">
            <div class="price">
              <span class="warn">$&nbsp;</span>
              <span class="price-size warn">{{(meta.promotionPrice || meta.originPrice) | price}}</span>
              <ng-container *ngIf="!!meta.promotionPrice">
                <span class="line-through padding-left">$ {{meta.originPrice | price}}</span>
              </ng-container>
            </div>
            <ng-container *ngIf="viewModel.apiResult().promotion as promotion">
              <button class="warn-tag" appFocusRemove
                      *ngIf="promotion.id && promotion.name"
                      (click)="toSales()">
                {{promotion.name}}
              </button>
            </ng-container>
          </div>
          <button appFocusRemove (click)="onClose()">
            <app-image-loading src="assets/icon_close_gray.svg" alt="關閉" i18n-alt
                               [clickable]="true"
                               [targetWidth]="18"
                               [targetHeight]="18"/>
          </button>
        </div>
        <app-color-selector (maxColorHeight)="updateContentHeight($event)"/>
        <div class="center-container space-between margin margin-top">
          <div class="title" i18n>尺寸</div>
          <div class="center-container">
            <button class="brown-text" appFocusRemove i18n *ngIf="viewModel.currentState.showDetail"
                    (click)="toDetail()">商品詳情</button>
            <button appFocusRemove class="brown-text center-container"
                    [class.fitting-padding]="viewModel.currentState.showDetail"
                    (click)="openFitting()">
              <span *ngIf="viewModel.apiResult().isBabyFitting; else fitting" i18n>適穿尺寸對照表</span>
              <ng-template #fitting><span i18n>真人試穿紀錄</span></ng-template>
              <app-image-loading class="padding-left" alt="對照表" i18n-alt
                                 src="assets/icon_arrow_right_brown.svg"
                                 [clickable]="true"
                                 [targetWidth]="7"
                                 [targetHeight]="12"/>
            </button>
          </div>
        </div>
        <button #syncWidth class="gray-item size-item sync-item wrapper">
          <div class="name">{{viewModel.longestSize()}}</div>
        </button>
        <div class="size-container wrap margin"
             [style.grid-template-columns]="'repeat(auto-fit, ' + syncWidth.offsetWidth + 'px)'">
          <ng-container *ngFor="let size of viewModel.cartSizes(); trackBy: sizeTrackByFn">
            <button appFocusRemove class="gray-item size-item"
                    [style.width.px]="syncWidth.offsetWidth"
                    [class.selected]="viewModel.currSize()?.size?.id === size?.size?.id"
                    [class.remind]="size?.stockRemind"
                    (click)="sizeClick(size)">
              <div class="name">{{size?.size?.name || ''}}</div>
            </button>
          </ng-container>
        </div>
        <div class="row-container space-between stepper margin">
          <span i18n>購買數量</span>
          <div class="relative">
            <button appFocusRemove class="center-container stepper-mask"
                    *ngIf="!viewModel.currColor() || !viewModel.currSize() || !viewModel.count()"
                    (click)="stepperMask()">
              <div class="content center-container">{{viewModel.count()}}</div>
            </button>

            <app-stepper [current]="viewModel.count()"
                         [max]="viewModel.currMax()"
                         [disabled]="!viewModel.count()"
                         [btnSize]="35"
                         [actionBtnSize]="35"
                         [stepperWidth]="113"
                         [actionImageSize]="14"
                         [remindExceededMax]="true"
                         [darkMode]="true"
                         (count)="viewModel.setCount($event)"/>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <button appFocusRemove class="common-button bottom-btn" (click)="addToCart()"
          [class.remind-btn]="viewModel.currSize()?.stockRemind">
    {{buttonText()}}
  </button>
</div>
